
import { useOrganization } from '@builddocs/data-management'
import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { OrgForSelect } from './Types'

export interface OrganizationProps {
  inn: string
  onLoad?: (value: OrgForSelect) => void
}

export const BuilddocsOrganization = ({ inn, onLoad }: OrganizationProps) => {
  const { organization, isLoading } = useOrganization(inn)

  const organizationName = organization?.name

  useEffect(() => {
    if(onLoad && organizationName) {
      onLoad({ inn, label: organizationName })
    }
  }, [organizationName])
  
  if(isLoading) {
    return <Typography color="primary">Поиск организации...</Typography>
  }


  return <Typography color="primary">{organizationName}</Typography>
}
